import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="internallinks"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index.js'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/InternalLinks/router.js
 **/